import type { MissionGraphData } from "./types";
import type { SeededRandom } from "../core/SeededRandom";

export function createMissionGraph(random?: SeededRandom): MissionGraphData {
  return {
    nodes: [
      { id: "start", name: "Зал прорыва", required: true },
      { id: "encounter", name: "Контактный зал", required: true },
      { id: "hub", name: "Узловой терминал", required: true },
      { id: "supply", name: "Складской отсек", required: false },
      { id: "secret", name: "Скрытый тайник", required: false },
      { id: "tech", name: "Служебная магистраль", required: true },
      { id: "toxic", name: "Цех охлаждения", required: true },
      { id: "dark", name: "Обесточенный сектор", required: true },
      { id: "finale", name: "Пункт эвакуации", required: true },
    ],
    edges: [
      { from: "start", to: "encounter", kind: "main" },
      { from: "encounter", to: "hub", kind: "main" },
      { from: "hub", to: "tech", kind: "main" },
      { from: "tech", to: "toxic", kind: "main" },
      { from: "toxic", to: "dark", kind: "main" },
      { from: "dark", to: "finale", kind: "main" },
      { from: "hub", to: "supply", kind: "branch" },
      { from: "supply", to: "secret", kind: "secret" },
      { from: "supply", to: "tech", kind: "loop" },
      ...(random?.chance(0.5) ? [{ from: "supply", to: "dark", kind: "loop" } as const] : []),
    ],
    mainPath: ["start", "encounter", "hub", "tech", "toxic", "dark", "finale"],
  };
}
